 (function () {
      // 获取当前 URL 的路径和查询参数
      const currentPath = window.location.pathname;
      const currentHost = window.location.host;
      console.log('Current path:', currentPath);
      var position = 'right: 40px';
      var mobilePosition = 'right: 20px';
      var translate = "translate(-18%, 0)"
      var mobileTranslate = "translate(-12.5%, 0)"
      if(currentPath.indexOf('/ar') != -1 && currentHost == 'innaio.com'){
        position = 'left: 40px';
        mobilePosition = 'left: 20px';
        translate = "translate(18%, 0)";
        mobileTranslate = "translate(12.5%, 0)"
      }
      var host = "https://www.panda72.ai", url = host + "/chatsdk/dialogue?img=2024-7-2/0a4b9ac3-eb22-4d5e-b010-060c527465c4.png&backgroundUrl=null&mobileImg=2024-7-2/0ef6732a-1053-4419-8797-75164bed680d.png&uid=8ce8bb06-e2ca-45d6-9a15-a051f67a21a6&secret=4FNAsTQ3TRxbnJNZ3qY7ztbwwSqmLzjq&appid=8kKXNzXNQ0Ml8UaM&type=1&embed=1";
      var wrapDiv = document.createElement("div");
      wrapDiv.id = "laipic-ai-embed";
      var container = document.createElement("div");
      container.id = "laipic-ai-container";
      var stylesheet = document.createElement("style");
      stylesheet.innerHTML = `\n  #laipic-ai-embed {\n    z-index: 9999;\n    position: fixed;\n    ${position};\n    bottom: 40px;\n    width: 102px;\n    height: 102px;\n    border-radius: 50%;\n    border: 2px solid #fff;\n    box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.12);\n    transition: all linear 0.1s;\n    overflow: hidden;\n    opacity: 0;\n    visibility: hidden;\n  }\n  #laipic-ai-embed.app-show {\n    ${mobilePosition};\n    bottom: 20px;\n    width: 77px;\n    height: 77px;\n    opacity: 1;\n    visibility: visible;\n  }\n  #laipic-ai-embed.show {\n    opacity: 1;\n    visibility: visible;\n  }\n  #laipic-ai-embed.app-default {\n    height: 260px;\n    width: 350px;\n    border: 0;\n    border-radius: 8px;\n  }\n  #laipic-ai-embed.default {\n    height: 626px;\n    width: 714px;\n    border: 0;\n    border-radius: 8px;\n  }\n   #laipic-ai-embed.full-screen {\n    height: 100%;\n    width: 100%;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    border: 0;\n    border-radius: 0;\n  }\n  #laipic-ai-container {\n    width: 100%;\n    height: 100%;\n  }\n  #laipic-ai-container iframe {\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n`;
      var userAgent = navigator.userAgent;
      var mobileKeywords = ["Android","iPhone","iPad","Windows Phone","BlackBerry","Kindle","webOS","Mobile"];
      var isMobile = mobileKeywords.some((keyword) => userAgent.includes(keyword));
      var iframe = document.createElement("iframe");
      iframe.id = "laipic-ai-iframe"; iframe.allowFullscreen = !1; iframe.title = "Laipic AI Embed"; iframe.role = "dialog"; iframe.src = url; iframe.allow = "microphone";
      iframe.style = isMobile? "width: 77px; height: 77px;" : "width: 102px; height: 102px;";
      var visible = !1, initial = !1, layout = isMobile? "app-default":"default", show = isMobile ? "app-show":"show";
      window.addEventListener("message", function (e) {
          if (e.origin === host && e.data && e.data.type && "laipic-ai-embed" === e.data.type) {
            if (e.data.action === "init") {
              initial = !0;
              wrapDiv.classList.toggle(show, initial);
            }
            if (e.data.action === "show") {
              visible = !0;
              wrapDiv.classList.toggle(layout, visible);
              iframe.style.width = isMobile ? "calc(260px * 16 / 9)" : "calc(626px * 16 / 9)";
              iframe.style.height = isMobile ? "260px" : "626px";
              iframe.style.transform = isMobile ? mobileTranslate : translate;
            }
            if (e.data.action === "hide") {
              visible = !1;
              wrapDiv.classList.toggle(layout, visible);
              iframe.style.width = isMobile ? "77px": "102px";
              iframe.style.height = isMobile ? "77px": "102px";
              iframe.style.transform = "none";
            }
            if (["init","show"].includes(e.data.action)) {
              var appCssStyle = "\n  .intl-theme {\n    min-width: 77px!important;\n  }\n  .intl-theme .dialogue-scoped .dialogue-layout .close-img {\n    right: 16rem;\n    top: 3rem;\n    width:3.5rem;\n  }\n  .intl-theme .dialogue-scoped .dialogue-layout .loading {\n    position: fixed;\n  }"
              var cssStyle = "\n  .intl-theme {\n    min-width: 102px!important;\n  }\n  .intl-theme .dialogue-scoped .dialogue-layout .close-img {\n    right: 23rem;\n  }";
              var url = window.location.href;
              var params  = {};
              url.replace(/[?&]+([^=&]+)=([^&]*)/gi,function(s,key,value){params[key] = value;});
              var message = { cssStyle: isMobile ? appCssStyle: cssStyle, layout:{ embedBtn: false },vConsole: !!params.vConsole, sdkVconsole: !!params.sdkVconsole };
              iframe.contentWindow.postMessage(message, "*");
            }
          }
        });
      container.appendChild(iframe);
      wrapDiv.appendChild(stylesheet);
      wrapDiv.appendChild(container);
      document.body.appendChild(wrapDiv);
    })()
